<script setup lang="ts" generic="T">
  import { computed } from 'vue';
  import { usePaginationEntities, type EntityType } from '@/shared/lib';

  const props = defineProps<{
    allItems: T[];
    loadingMore: boolean;
    hasMoreItems: boolean;
    metadata?: { total?: number; totalItems?: number } | null;
    entityName?: EntityType;
    hideSummary?: boolean;
  }>();

  const { getEntityConfig } = usePaginationEntities();
  const getEntityPlural = computed(() => getEntityConfig(props.entityName).plural);
</script>

<template>
  <slot
    name="table"
    :items="allItems"
  />
  <div
    v-if="allItems.length > 0 && !hideSummary"
    data-testid="infinite-scroll-summary"
    class="text-md pt-2 pl-8 text-gray-03"
  >
    Mostrando 1-{{ allItems.length }} de
    {{ metadata?.totalItems ?? metadata?.total ?? allItems.length }}
    {{ getEntityPlural }}
  </div>

  <div
    id="infinite-scroll-trigger"
    class="py-4 text-center"
  >
    <div
      v-if="loadingMore"
      data-testid="infinite-scroll-loading"
      class="py-2"
    >
      <span class="inline-block animate-spin mr-2">⟳</span>
      Carregando mais {{ getEntityPlural }}...
    </div>
    <div
      v-else-if="!hasMoreItems && allItems.length > 0"
      data-testid="infinite-scroll-end"
      class="py-2 text-gray-500"
    >
      Não há mais {{ getEntityPlural }} para carregar
    </div>
    <div
      v-else-if="allItems.length > 0"
      class="py-2 opacity-0"
    >
      Carregando...
    </div>
  </div>
</template>
